import parentProfile from '@/api/parent-profile'
import branchAPI from '@/api/branch'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  nationalities: [],
  occupations: [],
  notificationPrivacys: [],
  photoBlob: '',
  provinces: [],
  agreement: [],
  father_photo_exists: null,
  mother_photo_exists: null,
  pickup_card: null,
  id_card_activated: null,
  used_app: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_NATIONALITY(state, data) {
    state.nationalities = data
  },
  SET_OCCUPATION(state, data) {
    state.occupations = data
  },
  SET_PHOTO_BLOB(state, blob) {
    state.photoBlob = blob
  },
  SET_NOTIFICATION_TYPE(state, notifications) {
    state.notificationPrivacys = notifications
  },
  SET_PROVINCE(state, provinces) {
    state.provinces = provinces
  },
  SET_AGREEMENT(state, agreement) {
    state.agreement = agreement
  },
  SET_FATHER_PHOTO_EXISTS(state, data) {
    state.father_photo_exists = data
  },
  SET_MOTHER_PHOTO_EXISTS(state, data) {
    state.mother_photo_exists = data
  },
  SET_PICKUP_CARD(state, data) {
    state.pickup_card = data
  },
  SET_ID_CARD_ACTIVATED(state, data) {
    state.id_card_activated = data
  },
  SET_USED_APP(state, data) {
    state.used_app = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        father_photo_exists: context.state.father_photo_exists,
        mother_photo_exists: context.state.mother_photo_exists,
        pickup_card: context.state.pickup_card,
        id_card_activated: context.state.id_card_activated,
        used_app: context.state.used_app
      },
      attrubutes
    )
    return parentProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return parentProfile.store(data)
  },

  update(context, data) {
    return parentProfile.update(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await parentProfile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return parentProfile.destroy(id)
  },
  children(context, data) {
    return parentProfile.children(data)
  },
  privacy(context, data) {
    return parentProfile.privacy(data)
  },
  saveAgreement(context, data) {
    return parentProfile.saveAgreement(data)
  },
  generateCard(context, data) {
    return parentProfile.generateCard(data)
  },
  async uploadParentPhoto(context, data) {
    return parentProfile.uploadPhoto(data)
  },
  async getNationality(context) {
    if (!context.state.nationalities.length > 0) {
      let response = await parentProfile.notionality()
      context.commit('SET_NATIONALITY', response.data)
      return response
    }
  },
  async getOccupation(context) {
    if (!context.state.occupations.length > 0) {
      let response = await parentProfile.occupation()
      context.commit('SET_OCCUPATION', response.data)
      return response
    }
  },
  async getNotificationType(context) {
    if (!context.state.notificationPrivacys.length > 0) {
      let response = await parentProfile.notificationType()
      context.commit('SET_NOTIFICATION_TYPE', response.data)
      return response
    }
  },
  async getProvince(context) {
    if (!context.state.provinces.length > 0) {
      let response = await parentProfile.province()
      context.commit('SET_PROVINCE', response.data)
      return response
    }
  },
  async getAgreement(context) {
    if (!context.state.agreement.length > 0) {
      let response = await parentProfile.agreement()
      context.commit('SET_AGREEMENT', response.data)
      return response
    }
  },
  getDistrict(context, province_code) {
    return parentProfile.district(province_code)
  },
  getCommune(context, distirct_code) {
    return parentProfile.commune(distirct_code)
  },
  getVillage(context, commune_code) {
    return parentProfile.village(commune_code)
  },
  getBranch(context) {
    return branchAPI.get({
      params: {
        page: -1,
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        }
      }
    })
  }
}
